import { Link, isRouteErrorResponse, useRouteError } from 'react-router'
import { Container } from '@/components/layout'
import { Seo } from '@/components/Seo'
import { Button } from '@/components/ui/button'

/** Erro inesperado ao montar uma página (inclui falha ao baixar uma parte do site após atualização). */
export function RouteErrorPage() {
  const error = useRouteError()
  const chunkFailed =
    error instanceof Error && /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(error.message)
  const notFound = isRouteErrorResponse(error) && error.status === 404

  if (import.meta.env.DEV) console.error(error)

  return (
    <Container className="flex min-h-dvh max-w-xl flex-col justify-center gap-6 py-20">
      <Seo title={notFound ? 'Página não encontrada' : 'Algo deu errado'} noIndex />
      <p className="text-sm font-medium text-muted-foreground">Poder Aberto</p>
      <h1 className="text-3xl font-semibold tracking-tight">
        {notFound ? 'Página não encontrada' : chunkFailed ? 'O site foi atualizado' : 'Algo deu errado'}
      </h1>
      <p className="text-lg leading-relaxed text-muted-foreground">
        {notFound
          ? 'O endereço pode estar incorreto ou a página pode ter sido removida.'
          : chunkFailed
            ? 'Uma nova versão do Poder Aberto foi publicada. Recarregue a página para continuar.'
            : 'Não foi possível exibir esta página. Tente recarregar; se o problema continuar, volte mais tarde.'}
      </p>
      <div className="flex flex-wrap gap-3">
        <Button onClick={() => window.location.reload()}>Recarregar</Button>
        <Button asChild variant="outline">
          <Link to="/">Ir para a página inicial</Link>
        </Button>
      </div>
    </Container>
  )
}
